import React from "react";
import { Box, Flex, Heading, Text, Stack } from "@chakra-ui/core";

import LandingPageHeader from "../components/elements/LandingPageHeader";
import PhoneMockup from "../components/mockups/PhoneMockup";
import ChatMockup from "../components/mockups/ChatMockup";
import { isLoggedIn } from "../utils/auth";
import Dashboard from "./Dashboard";
import Footer from "../components/common/Footer";
import CallToAction from "../components/elements/CallToAction";
import LandingSectionTwo from "../components/landing/LandingSectionTwo";
import LandingSectionThree from "../components/landing/LandingSectionThree";
import LandingSectionFour from "../components/landing/LandingSectionFour";
import LandingSectionFive from "../components/landing/LandingSectionFive";

function Landing() {
  // if the user is already logged in we redirect to dashboard
  if (isLoggedIn()) {
    return <Dashboard />;
  } else
    return (
      <>
        <LandingPageHeader landing={true} />
        <Flex
          minH="100vh"
          background="radial-gradient(circle at 82% 46%, rgba(209,250,206, 0.28) 0%, rgba(209,250,206, 0.28) 3%,transparent 3%, transparent 100%),
          radial-gradient(circle at 69% 5%, rgba(10,118,67, 0.06) 0%, rgba(10,118,67, 0.06) 3%,transparent 3%, transparent 100%),
          radial-gradient(circle at 38% 80%, rgba(10,118,67, 0.06) 0%, rgba(10,118,67, 0.06) 3%,transparent 3%, transparent 100%),
          radial-gradient(circle at 75% 68%, rgba(209,250,206, 0.28) 0%, rgba(209,250,206, 0.28) 7%,transparent 7%, transparent 100%),
          radial-gradient(circle at 44% 77%, rgba(209,250,206, 0.28) 0%, rgba(209,250,206, 0.28) 7%,transparent 7%, transparent 100%),
          radial-gradient(circle at 58% 79%, rgba(10,118,67, 0.06) 0%, rgba(10,118,67, 0.06) 7%,transparent 7%, transparent 100%),
          radial-gradient(circle at 64% 48%, rgba(10,118,67, 0.06) 0%, rgba(10,118,67, 0.06) 5%,transparent 5%, transparent 100%),
          radial-gradient(circle at 18% 100%, rgba(10,118,67, 0.06) 0%, rgba(10,118,67, 0.06) 5%,transparent 5%, transparent 100%),
          linear-gradient(135deg, rgb(252,252,252),rgb(252,252,252));"
        >
          <Flex maxW="1490px" flexWrap="wrap" m="auto" w="100%">
            <Box
              minWidth="340px"
              pt={["100px", "130px", "130px", "0px"]}
              w={["100%", "100%", "100%", "50%"]}
              px="16px"
              m="auto"
            >
              <Box m="auto" w="100%" maxW="xl" textAlign={["center","center","left","left"]}>
                <Heading
                  as="h1"
                  size="2xl"
                  lineHeight="normal"
                  fontWeight="bolder"
                  color="primary.500"
                >
                    Get paid faster,
                  <Box as="span" color="success.500">
                    {" "}<br/>
                    with sharable links
                  </Box>
                </Heading>

                <Text opacity="0.7" fontSize="lg" mt="2">
                  Whether you provide tailored services or receive orders offline, 
                  let your customers secure orders or book your services, just by following a link for payment.
                </Text>

                <Stack isInline justifyContent={["center","center","flex-start","flex-start"]} w="100%" my="1.5rem">
                  <CallToAction />
                </Stack>
              </Box>
            </Box>

            <Box
              pt={["30px", "40px", "50px", "0px"]}
              pb="40px"
              w={["100%", "100%", "100%", "50%"]}
            >
              <PhoneMockup>
                <ChatMockup />
              </PhoneMockup>
            </Box>
          </Flex>
        </Flex>

        <LandingSectionTwo />
        <Box
          display={["none", "none", "block", "block"]}
          background={[
            "#ffffff",
            "#ffffff",
            "#ffffff",
            "linear-gradient(to right, #ffffff 50%, #ffffff 50%)",
          ]}
          h="48px"
          className="triangle-separator-alt"
        ></Box>
        <LandingSectionThree />
        <LandingSectionFour />
        <Box
          display={["none", "none", "block", "block"]}
          background="#fff"
          h="48px"
          className="triangle-separator-alt-yellow"
        ></Box>
        <LandingSectionFive />
        <Footer />
      </>
    );
}

export default Landing;